<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Listado de Vendedores</p>
        </template>
        <b-row>                            
            <b-col cols="12" md="12">
                <div class="text-right">
                    <b-button variant="info" class="text-white" :to="{name: 'registrarUsuario'}">Nuevo Usuario</b-button>
                </div>
            </b-col>
        </b-row>
        <b-card-text>
            <b-table 
                responsive
                :fields="computedFields" 
                striped hover 
                :items="users">
                <template v-slot:cell(nombre)="data">
                    {{ data.item.nombre }}
                </template>
                <template v-slot:cell(email)="data">
                    {{ data.item.email }}
                </template>
                <template v-slot:cell(telefono)="data">
                    {{ data.item.telefono }}
                </template>
                <template v-slot:cell(commission_percentage_on_sales)="data" v-if="canSuperviseSalesComission">
                    {{ data.item.commission_percentage_on_sales }}
                </template>
                <template v-slot:cell(status)="data">
                    <b-badge v-if="data.item.status == 1" variant="success">
                        Activo
                    </b-badge>
                    <b-badge v-else variant="danger">
                        Inactivo
                    </b-badge>
                </template>
                <template v-slot:cell(reset_password)="{ item }" v-if="canResetPassword">
                    <b-button variant="danger" size="sm" v-b-tooltip.hover title="Nueva Contraseña" class="text-white" @click.prevent="$emit('open-reset-pass-modal', item)">
                        <b-icon icon="wrench"></b-icon>
                    </b-button>
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button variant="info" size="sm" v-b-tooltip.hover.right title="Editar" class="text-white" 
                    :to="{name: 'updateUser', params:{ id: item.id}}">
                        <b-icon icon="pencil"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <template v-if="users.length < 1">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        </b-card-text>
        <template v-slot:footer>
            <b-row class="tipo-vistas-card justify-content-md-center">
                <b-col cols="12" sm="1">
                    <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                </b-col>                    
                <b-col cols="12" md="4">
                    <b-pagination 
                        size="md" 
                        pills 
                        :total-rows="paginator.totalPage" 
                        v-model="paginator.page" 
                        :per-page="1" 
                        @input="changePage" 
                        first-number 
                        last-number>
                    </b-pagination>
                </b-col>
            </b-row>
        </template>
    </b-card>
</template>

<script>
export default {
    name: "UsersTable",
    props: {
        users: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        },
        canResetPassword: {
            type: Boolean
        },
        canSuperviseSalesComission: {
            type: Boolean
        }
    },
    computed: {
        computedFields() {
            return this.fields.filter((field) => {
                if (field.requiresPermission) {
                    if (field.key === "reset_password") {
                        return this.canResetPassword;
                    } else if (field.key === "commission_percentage_on_sales") {
                        return this.canSuperviseSalesComission;
                    }
                } else {
                    return true;
                }
            });
        },
    },
    data(){
        return{
            fields: [
                { key: 'nombre', label: 'Nombre Vendedor', sortable: true},
                { key: 'email', label: 'Correo electronico', sortable: true},
                { key: 'telefono', label: 'Telefono'},
                { key: 'commission_percentage_on_sales', label: '% Comisión de venta', sortable: true, requiresPermission: true},
                { key: 'reset_password', label: 'Password', requiresPermission: true },
                { key: 'status', label: 'Estado', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
        }
    },
    methods: {
        updatePageSize(){
            /* the page sizee return the current page to initial because we can't know if the current page have items asigned!! */
            this.paginator.page = 1;
            /* emit the page size update to get the new list of items*/
            this.$emit('get-users-list');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);
        }
    }
};

</script>
<style scoped>

</style>